var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowThinLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Defaults_thin_left",
    transform: "translate(24 24) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M5.259,8.934,5.191,8.89l-5.043-4a.352.352,0,0,1-.065-.514L.14,4.316,5.183.117a.549.549,0,0,1,.677,0,.35.35,0,0,1,.055.509L5.86.68,1.872,4H20.524A.489.489,0,0,1,21,4.5a.494.494,0,0,1-.391.492L20.524,5H1.68L5.852,8.313a.351.351,0,0,1,.07.507l-.054.057A.528.528,0,0,1,5.522,9,.548.548,0,0,1,5.259,8.934Z",
    transform: "translate(2 8)",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThinLeft);
export default __webpack_public_path__ + "static/media/_arrow_thin_left.69f989243c4f2a12f8c42ef938fd0f37.svg";
export { ForwardRef as ReactComponent };